import { api } from '@/api/client';
import type { ClarityConfigResponse, CrispConfigResponse, GuestVisitPayload } from '@/api/types';

export const trackingApi = {
  guestVisit: (payload: GuestVisitPayload) => api.post<{ ok: boolean }>('/guest-visit', payload),
  heartbeat: () => api.post<{ ok: boolean }>('/heartbeat', {}),
  clarityConfig: () => api.get<ClarityConfigResponse>('/clarity-config'),
  crispConfig: () => api.get<CrispConfigResponse>('/crisp-config'),
};
